<mat-icon [ngClass]="enabledUp ? 'enabled-arrow' : 'disabled-arrow'"
          [matTooltip]="enabledUp ? ('forms.common.controls.move_up.tooltip' | translate) : null"
          matTooltipPosition="above"
          class="row-action-icon text-right"
          (click)="enabledUp ? changePositionClicked(true) : ''">
  arrow_upward
</mat-icon>
<mat-icon [ngClass]="enabledDown ? 'enabled-arrow' : 'disabled-arrow'"
          [matTooltip]="enabledDown ? ('forms.common.controls.move_down.tooltip' | translate) : null"
          matTooltipPosition="below"
          class="row-action-icon text-right"
          (click)="enabledDown ?changePositionClicked(false) : ''">
  arrow_downward
</mat-icon>
